import '../scss/main.scss';

import Flickity from 'flickity';
import 'flickity/dist/flickity.css';

import ScrollMagic from 'scrollmagic/scrollmagic/uncompressed/ScrollMagic';
import 'scrollmagic/scrollmagic/uncompressed/plugins/animation.gsap';
import 'scrollmagic/scrollmagic/uncompressed/plugins/debug.addIndicators';
import TweenMax from 'gsap/TweenMax';
import TimelineMax from 'gsap/TimelineMax';

window.addEventListener('DOMContentLoaded', () => {
	let blockCarouselContainers = document.querySelectorAll('.box-type-carousel');

	if (blockCarouselContainers.length < 1) {
		return;
	}

	blockCarouselContainers = [].slice.call(blockCarouselContainers);

	blockCarouselContainers.forEach(container => {
		new Flickity(container, {
			contain: true,
			pageDots: true,
			prevNextButtons: false,
			autoPlay: true,
			wrapAround: true,
			setGallerySize: false,
			cellSelector: '.box-type-carousel .image-wrapper',
			cellAlign: 'left'
		});
	});
});

// Init parallax
window.addEventListener('DOMContentLoaded', () => {
	// Animaties
	let tooSmall = false;
	const maxWidth = 900;

	if ( window.innerWidth < maxWidth ) {
		tooSmall = true;
	}

	function initScrollMagic() {
		const controller = new ScrollMagic.Controller();

		let boxesRows = document.querySelectorAll('.content-wrapper.module-boxes-overlap');
		boxesRows = [].slice.call(boxesRows);

		boxesRows.forEach((boxesRow, index) => {

			const boxImage = boxesRow.querySelector('.box-type-image');
			const boxText = boxesRow.querySelector('.box-type-text');
			const boxCarousel = boxesRow.querySelector('.box-type-carousel');

			const parallaxTl = new TimelineMax();

			if ( boxImage ) {
				parallaxTl.to(boxImage, 1, { y: '15%', ease:Linear.easeNone }, 'imageAnim');
			}

			if ( boxText ) {
				parallaxTl.to(boxText, 1, { y: '-15%', ease:Linear.easeNone }, 'imageAnim');
			}

			if ( boxCarousel ) {
				parallaxTl.to(boxCarousel, 1, { y: '15%', ease:Linear.easeNone }, 'imageAnim');
			}

			new ScrollMagic.Scene({
				triggerElement: boxesRow,
				triggerHook: 1,
				offset: 50,
				duration: '100%'
			}).setTween(parallaxTl).addTo(controller);
		});

		boxesRows.forEach((boxesRow, index) => {
			const boxImage = boxesRow.querySelector('.box-type-image') ? boxesRow.querySelector('.box-type-image') : document.createElement('div');
			const boxCarousel = boxesRow.querySelector('.box-type-carousel') ? boxesRow.querySelector('.box-type-carousel') : document.createElement('div');
			const boxText = boxesRow.querySelector('.box-type-text') ? boxesRow.querySelector('.box-type-text') : document.createElement('div');
			const boxTextTitle = boxesRow.querySelector('.box-type-text h1') ? boxesRow.querySelector('.box-type-text h1') : document.createElement('div');
			const boxTextParagraph = boxesRow.querySelector('.box-type-text p') ? boxesRow.querySelector('.box-type-text p') : document.createElement('div');

			const animateIn = new TimelineMax();

			if ( boxImage ) {
				animateIn.from(boxImage, .7, { x: '-=50px', autoAlpha: 0 }, 'animBoxImageIn');
			}

			if ( boxCarousel ) {
				animateIn.from(boxCarousel, .7, { x: '-=50px', autoAlpha: 0 }, 'animBoxCarouselIn');
			}

			if ( boxText ) {
				animateIn.from(boxText, .7, { autoAlpha: 0 }, 'animTextBlockIn');
				if ( boxTextTitle ){
					animateIn.from(boxTextTitle, .5, { y: '-=25px', autoAlpha: 0 }, 'animTextBlockIn+=0.15');
				}
				if ( boxTextParagraph ){
					animateIn.from(boxTextParagraph, .5, { y: '-=25px', autoAlpha: 0 }, 'animTextBlockIn+=0.25');
				}
			}

			new ScrollMagic.Scene({
				triggerElement: boxesRow,
				triggerHook: 'onEnter',
				offset: '100',
				reverse: false
			}).setTween(animateIn).addTo(controller);
		});
	}

	if (!tooSmall) {
		initScrollMagic();
	}
});